import { useEffect, useState } from 'react';
import { EventBus } from '@vtblife/event-bus';
import get from 'lodash/get';
export const useAuthorizedUser = () => {
    const [user, setUser] = useState(null);
    useEffect(() => {
        const eventBus = EventBus.getInstance();
        const subscription = eventBus === null || eventBus === void 0 ? void 0 : eventBus.subscribe('app:contextChanged', (event) => {
            const newUser = get(event, 'data.authInfo.user');
            setUser(newUser);
        }, { eventCategory: 'behavior' });
        return () => subscription.unsubscribe();
    }, []);
    return user;
};
//# sourceMappingURL=use-authorized-user.js.map